document.querySelectorAll('[data-pdp-faq]').forEach(function (cloud) {
  cloud.querySelectorAll('[data-faq-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq-item]');
      var willOpen = !item.classList.contains('is-open');

      cloud.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var openBtn = openItem.querySelector('[data-faq-trigger]');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      });

      if (willOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
